<template>
  <div>
    <template v-if="grp_id === statement">
      <CommonStatementDocument :grpId="grp_id" />
    </template>
    <template v-else>
      <CommonPreUpload :grpId="grp_id" />
    </template>
  </div>
</template>

<script>
export default {
  components: {
    CommonStatementDocument: () =>
      import("@/components/TemplateNewScreen/CommonStatementDocument.vue"),
    CommonPreUpload: () =>
      import("@/components/TemplateNewScreen/CommonPreUpload.vue"),
  },
  data() {
    return {
      userData: {},
      grp_id: null,
      statement: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT,
    };
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.userData = this.$store.getters.getUserData;
    this.grp_id = this.userData.grpId;
  },
};
</script>
